import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import apiCall from "../../API/API";
import moment from "moment";
import { set } from "lodash";
import { IoSend } from "react-icons/io5";
import { SOCKET_SERVER_URL_WSS } from "../../API/API";

// const SOCKET_SERVER_URL = "wss://testing.aumron.co/";
// const SOCKET_SERVER_URL = "wss://apis.aumron.com";
const SOCKET_SERVER_URL = SOCKET_SERVER_URL_WSS;

const ChatTickets = () => {
  const location = useLocation();
  const { ticketid } = location.state || {};
  const [tickets, setTickets] = useState([]);
  const [socket, setSocket] = useState(null);
  const wsRef = useRef(null);
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reconnectTimeoutRef = useRef(null);
  const commentsContainerRef = useRef(null);

  const initializeWebSocket = () => {
    if (wsRef.current) {
      console.log("Closing existing WebSocket connection...");
      wsRef.current.close();
    }
    const newSocket = new WebSocket(SOCKET_SERVER_URL);

    newSocket.onopen = () => {
      console.log("WebSocket connected.");
      newSocket.send(JSON.stringify({ type: "subscribe", ticketId: ticketid }));
      console.log("connected already");
    };

    console.log("now message turn");

    newSocket.onmessage = (event) => {
      console.log("Raw WebSocket message:", event.data);
      try {
        const message = JSON.parse(event.data);
        console.log("Received WebSocket message:", message);

        if (message.commentId) {
          // Case: New user message is received
          console.log("New user comment:", message);
          setComments((prev) => {
            const isDuplicate = prev.some(
              (c) => c.commentId === message.commentId
            );
            return isDuplicate ? prev : [...prev, message]; // Prevent duplicates
          });
        } else if (message.data) {
          // Case: Data object is received (existing messages)
          console.log("Previous comments received:", message.data);
          setComments((prevComments) => [...prevComments, ...message.data]);
        } else {
          console.warn("Unexpected WebSocket message format:", message);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    newSocket.onclose = () => {
      console.log("WebSocket disconnected. Reconnecting...");
      reconnectWebSocket();
    };

    wsRef.current = newSocket;
  };

  useEffect(() => {
    console.log("Updated comments state:", comments);
  }, [comments]);

  const reconnectWebSocket = () => {
    if (reconnectTimeoutRef.current) return;
    reconnectTimeoutRef.current = setTimeout(() => {
      initializeWebSocket();
      reconnectTimeoutRef.current = null;
    }, 5000);
  };

  useEffect(() => {
    if (ticketid) {
      initializeWebSocket();
    }
    return () => {
      if (wsRef.current) wsRef.current.close();
      if (reconnectTimeoutRef.current)
        clearTimeout(reconnectTimeoutRef.current);
    };
  }, [ticketid]);

  const fetchData = async () => {
    setLoading(true);
    const filters = Object.fromEntries(
      Object.entries({ ticketId: ticketid }).filter(
        ([key, value]) => value !== ""
      )
    );
    const queryParams = {
      ...filters,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    const { data, error } = await apiCall(
      "GET",
      `/get-ticket?${queryString}`,
      null,
      false
    );
    if (error) {
      console.error(error.message);
    } else {
      console.log("ticketsssssssssssssssssssssssssssssssssss", data);
      setTickets(data);
      setComments(data?.comments || []);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ticketid) {
      fetchData();
    } else {
      setError("Ticket ID is missing");
      setLoading(false);
    }
  }, [ticketid]);

  useEffect(() => {
    // Scroll to the bottom when comments change
    if (commentsContainerRef.current) {
      commentsContainerRef.current.scrollTop =
        commentsContainerRef.current.scrollHeight;
    }
  }, [comments]);

  const handleSendComment = async () => {
    if (!newComment.trim()) return;

    console.log(newComment);

    try {
      const body = {
        ticketId: ticketid,
        message: newComment,
      };
      const response = await apiCall("POST", `/add-comment`, body);
      console.log("Add Comment Response", response);
      // if (response?.message === "Admin comment added successfully") {
      //   fetchData();
      // }
      // setComments((prevComments) => [
      //   ...prevComments,
      //   {
      //     message: newComment,
      //     user_type: "admin",
      //     timestamp: new Date().toISOString(),
      //   },
      // ]);

      setNewComment("");
    } catch (error) {
      console.log("Error adding comment", error);
      setError("Failed to add comment");
    }
  };

  const groupCommentsByDate = (comments) => {
    return comments.reduce((acc, comment) => {
      const commentDate = moment(comment.timestamp).format("YYYY-MM-DD");
      if (!acc[commentDate]) {
        acc[commentDate] = [];
      }
      acc[commentDate].push(comment);
      return acc;
    }, {});
  };

  const groupedComments = groupCommentsByDate(comments);

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>{error}</div>;

  //   useEffect(() => {
  //     fetchData();
  //   }, []);
  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <h4 className="m-0">Chat Tickets</h4>
        </div>
        <h5>Ticket Title : {tickets?.subject}</h5>
        <span>Ticket Description : {tickets?.description}</span>

        {/* Display comments */}
        <div
          ref={commentsContainerRef}
          className="comments-container mt-4"
          style={{
            overflowY: "scroll",
            height: "45vh",
            borderRadius: "10px",
            boxShadow: "rgb(0 0 0 / 31%) -5px -5px 15px -1px",
            padding: "10px",
          }}
        >
          {comments.length === 0 ? (
            <div style={{ textAlign: "center", color: "#888" }}>
              Start the conversation
            </div>
          ) : (
            Object.keys(groupedComments).map((date) => (
              <div key={date}>
                <div style={{ textAlign: "center", margin: "10px 0" }}>
                  {/* Show the formatted date heading */}
                  {moment(date).format("MMMM D, YYYY")}
                </div>

                {groupedComments[date].map((comment) => (
                  <div
                    key={comment.commentId}
                    style={{
                      display: "flex",
                      justifyContent:
                        comment.user_type === "user"
                          ? "flex-start"
                          : "flex-end",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "60%",
                        padding: "10px",
                        paddingBottom: "5px",
                        backgroundColor:
                          comment.user_type === "user" ? "#f0f0f0" : "#d1e7dd",
                        borderRadius: "10px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <p style={{ margin: "0" }}>{comment.message}</p>
                      <small
                        className="d-flex justify-content-end ps-3"
                        style={{ fontSize: "10px" }}
                      >
                        {moment(comment?.timestamp).format("HH:mm")}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>

        {/* Message input box */}
        {/* <div
          className="userChatBox"
          style={{
            position: "relative",
            top: "10px",
            width: "100%",
            padding: "10px",
            backgroundColor: "#153D77",
            borderRadius: "10px",
            boxShadow: "rgb(0 0 0 / 31%) -5px -5px 15px -1px",
            zIndex: "9999",
            borderRadius: "10px",
          }}
        >
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Type a message..."
            rows="1"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ddd",
              minHeight: "50px",
              maxHeight: "80px",
            }}
          />
          <button onClick={handleSendComment} className="btnPrimary">
            Send
          </button>
        </div> */}
        <div
          className="userChatBox"
          style={{
            position: "relative",
            top: "10px",
            width: "100%",
            padding: "10px",
            backgroundColor: "#153D77",
            borderRadius: "10px",
            boxShadow: "rgb(0 0 0 / 31%) -5px -5px 15px -1px",
            zIndex: "9999",
            borderRadius: "10px",
          }}
        >
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Type a message..."
            rows="1"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ddd",
              minHeight: "50px",
              maxHeight: "80px",
              position: "relative",
            }}
          />
          <button
            style={{
              position: "absolute",
              top: "15px",
              right: "10px",
              width: "fit-content",
              color: "#153D77",
            }}
            onClick={handleSendComment}
            className="btnPrimary mb-0"
          >
            <IoSend size={22} />
          </button>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ChatTickets;
